import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';
import {currentCartIsEmpty} from './currentCartIsEmpty';

export const canCategorizeCurrentCartAssets = (): boolean => {
	if (currentCartIsEmpty()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;
	return currentUserHasAccess(PermissionName.ORGANIZE);
};
